/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { ArrowRight } from '@carbon/react/icons';
import { Button } from 'carbon-components-react';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { sharedMessages } from '../../messages';

interface WizardButtonProps {
  enableBack: boolean;
  enableNext: boolean;
  handleBack: (any) => void;
  handleNext: (any) => void;
  idType: string;
  showBack: boolean;
  showNext: boolean;
}
/*
 * "Quickstart" wizard buttons
 */
export const WizardButtons = ({
  enableBack,
  enableNext,
  handleBack,
  handleNext,
  idType,
  showBack,
  showNext
}: WizardButtonProps) => {
  const { formatMessage: t } = useIntl();

  return (
    <>
      <div className="ServiceDesk__divider"></div>
      <div className="TabContent__spacer16"></div>
      <div>
        {showBack && (
          <Button
            onClick={handleBack}
            disabled={!enableBack}
            size="sm"
            id={`${idType}-back`}>
            <FormattedMessage {...sharedMessages.back} />
          </Button>
        )}
        {showNext && (
          <Button
            onClick={handleNext}
            disabled={!enableNext}
            renderIcon={ArrowRight}
            iconDescription={t(sharedMessages.next)}
            size="sm"
            id={`${idType}-next`}>
            <FormattedMessage {...sharedMessages.next} />
          </Button>
        )}
      </div>
    </>
  );
};
